import React from 'react';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#8E44AD',
    marginLeft: '270px',
  },
}));

export default function GlobalLoader() {
  const classes = useStyles();
  return (
    <div>
      
      <Backdrop className={classes.backdrop} open={true} m={2} pt={3} >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}